import {useCallback, useEffect, useState} from "react";

const getWindowSize = () => {
    return {
        height: window.innerHeight,
        width: window.innerWidth
    }
}

export default function useWindowSize() {

    const [windowSize, setWindowSize] = useState(getWindowSize());

    const onResize = useCallback(() => {
        setWindowSize(getWindowSize());
    }, []);

    useEffect(() => {
        window.addEventListener("resize", onResize);

        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, [onResize]);

    return windowSize;
}
